import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import ProduttivoMuiThemeV1 from '../components/shared/themes/ProduttivoMuiThemeV1';
import AuthContainer from './security/AuthContainer'

const authSettings = document.getElementById('sso-container');

if (authSettings !== null) {
  const root = createRoot(authSettings);

  root.render(
    <ThemeProvider theme={ProduttivoMuiThemeV1}>
      <AuthContainer />
    </ThemeProvider>
  );
}
